import React from "react";
import { monthConverter } from "utils/common";
import { formatParasite } from "utils/parasite";

const patientNameColumnStyle = {
  minWidth: "260px",
  width: "260px",
  whiteSpace: "normal",
  overflowWrap: "break-word",
};

const TableComponent = ({
  reportsData,
  tableRef,
  reportInfo,
  currentLevel,
}) => {
  let levelName = "";
  let header = [],
    content = [];
  if (currentLevel === "national") {
    header.push("Nama Provinsi");
    header.push("Nama Kabupaten/Kota");
    header.push("Nama Fasyankes");
    content.push("province_name");
    content.push("district_name");
    content.push("fasyankes_name");
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    header.push("Nama Kabupaten/Kota");
    header.push("Nama Fasyankes");
    content.push("district_name");
    content.push("fasyankes_name");
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    header.push("Nama Fasyankes");
    content.push("fasyankes_name");
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-responsive"
      style={{ backgroundColor: "#fff" }}
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingBottom: 0 }}>
            <h3>
              SISMAL v3, Rekap Data Individu {formatParasite("Knowlesi")}
            </h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {periodeName === "Bulanan" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            {header.map((item, index) => (
              <th key={index + 100}>{item}</th>
            ))}
            <th style={patientNameColumnStyle}>Nama Pasien</th>
            <th>Kode Slide</th>
            <th>Alamat Domisili</th>
            <th>Pekerjaan</th>
            <th>Jenis Parasit</th>
            <th>Nama Lab Rujukan</th>
            <th>Tanggal pengiriman sampel</th>
            <th>Kondisi sampel Sediaan Apusan Darah (SAD)</th>
            <th>Umpan balik Sediaan Apusan Darah (SAD)</th>
            <th>Kondisi sampel Dried Blood Spot (DBS)</th>
            <th>Umpan balik sampel Dried Blood Spot (DBS)</th>
            <th>Kondisi sampel Whole Blood EDTA (WB)</th>
            <th>Umpan balik sampel Whole Blood EDTA (WB)</th>
            <th>Tanggal Keluar Hasil PCR</th>
            <th>Hasil Pemeriksaan PCR</th>
          </tr>
        </thead>
        <tbody>
          {reportsData?.length > 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                {content.map((col, i) => (
                  <td key={i + 100}>{item?.[col]}</td>
                ))}
                <td style={patientNameColumnStyle}>{item?.patient_name}</td>
                <td>{item?.slide_code}</td>
                <td>{item?.address}</td>
                <td>{item?.job}</td>
                <td>{formatParasite(item?.parasyte)}</td>
                <td>{item?.destination_lab_id.split("|")[1]}</td>
                <td>
                  {item?.sample_sad_send_date ||
                    item?.sample_dbs_send_date ||
                    item?.sample_wb_send_date ||
                    "-"}
                </td>
                <td>{item?.sample_sad_condition}</td>
                <td>{item?.sample_sad_feedback}</td>
                <td>{item?.sample_dbs_condition}</td>
                <td>{item?.sample_dbs_feedback}</td>
                <td>{item?.sample_wb_condition}</td>
                <td>{item?.sample_wb_feedback}</td>
                <td>{item?.pcr_finish_checking_date}</td>
                <td>{formatParasite(item?.pcr_checking_result)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={content.length + 15}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
